import styled from 'styled-components';
import { theme } from '@frameio/vapor';
import { Workspaces } from './components';
import { AllProjectsButton } from './components/AllProjectsButton';

type Props = {
  onItemSelected?: () => void;
};

export const Navigation = ({ onItemSelected }: Props) => {
  return (
    <Container>
      <AllProjectsButton />
      <Workspaces onItemSelected={onItemSelected} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  ${theme.mediaQueries.tablet} {
    left: 0;
    position: absolute;
    right: 0;
  }
`;
